

























import Vue, { PropType } from "vue";
import { NativeHealthState } from "@/utils/healthBridgeSchemas";

export default Vue.extend({
  name: "HealthSyncProgress",
  props: { state: { type: Object as PropType<NativeHealthState>, required: true } },
  computed: {
    title(): string {
      return this.state.status === "syncing" ? "Sincronização em andamento" : "Registros aguardando confirmação";
    },
    phaseLabel(): string {
      const phases: Record<string, string> = {
        reading: "Lendo os registros autorizados no aparelho.",
        uploading: "Enviando os registros autorizados para a Omint.",
        reconciling: "Confirmando o recebimento dos registros pela Omint.",
        paused: "O envio está pausado; os registros pendentes foram preservados.",
        idle: "A sincronização atualizará o progresso quando continuar."
      };
      return phases[this.state.sync.phase];
    }
  }
});
